export const GET_PAGE_CONTENT = "GET_PAGE_CONTENT";
export const GET_PAGE_CONTENT_SUCCESS = "GET_PAGE_CONTENT_SUCCESS";
export const GET_SIDE_NAV_DETAILS = "GET_SIDE_NAV_DETAILS";
export const GET_SIDE_NAV_DETAILS_SUCCESS = "GET_SIDE_NAV_DETAILS_SUCCESS";
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
